import { ConfigProvider, App as AntdApp } from 'antd';
import Montserrat from './assets/fonts/Montserrat.ttf';
import AppRouter from './config/router';
import { store } from './store/store';
import { Provider } from 'react-redux';
import { AppProvider } from './context/AppContext';

function App() {
  return (
    <Provider store={store}>
      <AppProvider>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: '#FAC38B',
              fontFamily: Montserrat,
            },
          }}
        >
          <AntdApp>
            <AppRouter />
          </AntdApp>
        </ConfigProvider>
      </AppProvider>
    </Provider>
  );
}

export default App;
